import { useScreener, type ScreenedBond } from "../screener/useScreener";

// Параметры по умолчанию совпадают с теми, что использует страница скринера.
// Если юзер пришёл из скринера, TanStack Query вернёт результат из кеша
// мгновенно. При прямом переходе (закладка, шаринг) — однократный fetch.
//
// Валюта бумаги заранее неизвестна (секид → currency лежит только в данных
// скринера), поэтому пробуем все три параллельно. TanStack Query шарит кэш
// между этим хуком и страницей скринера: ровно одна валюта была активна
// перед переходом — она и отдаст результат сразу, остальные фоном.
const DEFAULT_PARAMS = {
  board: "TQCB",
  target: 0.16,
  tax: "resident",
};
const CURRENCIES = ["RUB", "USD", "CNY"] as const;

export function useBondScreenInfo(secid: string): {
  isPending: boolean;
  isError: boolean;
  bond: ScreenedBond | undefined;
} {
  const queries = CURRENCIES.map((currency) =>
    useScreener({ ...DEFAULT_PARAMS, currency }),
  );
  const bond = queries
    .map((q) => q.data?.find((b) => b.secid === secid))
    .find((b) => b !== undefined);
  return {
    isPending: bond === undefined && queries.some((q) => q.isPending),
    isError: queries.every((q) => q.isError),
    bond,
  };
}
